<template>
  <div class="home">
    <div class="top">
      <el-row :gutter="40">
        <el-col :span="4" v-for="(item,i) in list" :key="i">
          <div class="grid-content bg-purple tabs">
            <h3 class="title">{{item.title}}</h3>
            <p class="num">{{item.num}}</p>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="30" class="echart">
        <el-col :span="8">
          <div class="com">
            <echart :id="'myChart'" :data="applayData" :style="{width: '100%', height: '100%'}"></echart>
            <el-select class="picker" v-model="totals" clearable placeholder="累计总数" size="mini">
              <el-option
                v-for="item in totalNum"
                :key="item.value"
                :label="item.label"
                :value="item.totals"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="com">
            <h3 class="title">各机构报名人数情况排名</h3>
            <el-table :data="tableData" height="310" border style="width: 100%">
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column prop="name" label="机构名称" width="180"></el-table-column>
              <el-table-column prop="num" label="报名人数" width="180"></el-table-column>
              <el-table-column prop="percent" label="百分比"></el-table-column>
            </el-table>
            <el-select class="picker" v-model="totals1" clearable placeholder="累计总数" size="mini">
              <el-option
                v-for="item in totalNum1"
                :key="item.value"
                :label="item.label"
                :value="item.totals"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="com">
            <echart
              :id="'specialChart'"
              :data="specialData"
              :style="{width: '100%', height: '100%'}"
            ></echart>
            <el-select class="picker" v-model="totals2" clearable placeholder="累计总数" size="mini">
              <el-option
                v-for="item in totalNum2"
                :key="item.value"
                :label="item.label"
                :value="item.totals"
              ></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="30" class="echart">
        <el-col :span="8">
          <div class="com">
            <echart :id="'cityChart'" :data="cityData" :style="{width: '100%', height: '100%'}"></echart>
            <div class="select">
              <el-select
                v-model="citys"
                size="mini"
                placeholder="全省"
                style="margin-right:10px"
                clearable
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-date-picker v-model="cityDate" type="year" size="mini" placeholder="2020"></el-date-picker>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="com">
            <echart :id="'organChart'" :data="organData" :style="{width: '100%', height: '100%'}"></echart>
            <div class="select">
              <el-select v-model="organ" size="mini" placeholder="选择机构" style="margin-right:10px">
                <el-option
                  v-for="item in organs"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-date-picker v-model="organDate" type="year" size="mini" placeholder="2020"></el-date-picker>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="com">
            <echart :id="'majorChart'" :data="majorData" :style="{width: '100%', height: '100%'}"></echart>
            <div class="select">
              <el-select v-model="major" size="mini" placeholder="选择专业" style="margin-right:10px">
                <el-option
                  v-for="item in majors"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-date-picker v-model="majorDate" type="year" size="mini" placeholder="2020"></el-date-picker>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import echart from "../components/charts";
import echarts from "echarts";

export default {
  name: "system",
  components: {
    echart
  },
  data() {
    return {
      total: "2017-7",
      ranking: "2017-7",
      list: [
        { title: "全省报名人数", num: "12345" },
        { title: "全省学员总数", num: "1345" },
        { title: "全省当月报名人数", num: "845" },
        { title: "较上月新增人数", num: "30" },
        { title: "全省机构总数", num: "345" },
        { title: "学员练习通过率", num: "80%" }
      ],
      citys: "武汉市",
      cityDate: "2020",
      totalNum: [
        {
          value: "选项1",
          label: "累计总数"
        },
        {
          value: "选项2",
          label: "2020年7月"
        },
        {
          value: "选项3",
          label: "2020年6月"
        },
        {
          value: "选项4",
          label: "2020年5月"
        },
        {
          value: "选项5",
          label: "2020年4月"
        }
      ],
      totals: "累计总数",
      totalNum1: [
        {
          value: "选项1",
          label: "累计总数"
        },
        {
          value: "选项2",
          label: "2020年7月"
        },
        {
          value: "选项3",
          label: "2020年6月"
        },
        {
          value: "选项4",
          label: "2020年5月"
        },
        {
          value: "选项5",
          label: "2020年4月"
        }
      ],
      totals1: "累计总数",
      totalNum2: [
        {
          value: "选项1",
          label: "累计总数"
        },
        {
          value: "选项2",
          label: "2020年7月"
        },
        {
          value: "选项3",
          label: "2020年6月"
        },
        {
          value: "选项4",
          label: "2020年5月"
        },
        {
          value: "选项5",
          label: "2020年4月"
        }
      ],
      totals2: "累计总数",
      options: [
        {
          value: "选项1",
          label: "武汉市"
        },
        {
          value: "选项2",
          label: "孝感市"
        },
        {
          value: "选项3",
          label: "襄樊市"
        },
        {
          value: "选项4",
          label: "随州市"
        },
        {
          value: "选项5",
          label: "荆门市"
        }
      ],
      organ: "机构一",
      organDate: "2020",
      organs: [
        {
          value: "选项1",
          label: "机构一"
        },
        {
          value: "选项2",
          label: "机构二"
        },
        {
          value: "选项3",
          label: "机构三"
        },
        {
          value: "选项4",
          label: "机构四"
        },
        {
          value: "选项5",
          label: "机构五"
        }
      ],
      major: "资料员",
      majorDate: "2020",
      majors: [
        {
          value: "选项1",
          label: "资料员"
        },
        {
          value: "选项2",
          label: "材料员"
        },
        {
          value: "选项3",
          label: "施工员"
        },
        {
          value: "选项4",
          label: "质检员"
        },
        {
          value: "选项5",
          label: "报价员"
        }
      ],

      tableData: [
        {
          name: "机构一",
          num: "135",
          percent: "20%"
        },
        {
          name: "机构二",
          num: "655",
          percent: "80%"
        },
        {
          name: "机构三",
          num: "185",
          percent: "26%"
        },
        {
          name: "机构四",
          num: "265",
          percent: "26%"
        },
        {
          name: "机构五",
          num: "235",
          percent: "30%"
        },
        {
          name: "机构六",
          num: "15",
          percent: "10%"
        },
        {
          name: "机构七",
          num: "355",
          percent: "70%"
        },
        {
          name: "机构八",
          num: "235",
          percent: "50%"
        }
      ],
      // 各地市州报名人数
      applayData: {
        title: {
          text: "各地市州报名人数",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          type: "scroll",
          left: "center",
          top: "bottom",
          data: [
            "武汉",
            "黄石",
            "襄阳",
            "鄂州",
            "宜昌",
            "十堰",
            "孝感",
            "荆门",
            "鄂州",
            "黄冈",
            "咸宁",
            "随州"
          ]
        },
        series: [
          {
            name: "类型",
            type: "pie",
            radius: "50%",
            center: ["50%", "50%"],
            data: [
              { value: 335, name: "武汉", itemStyle: { color: "#008A63" } },
              { value: 135, name: "黄石", itemStyle: { color: "#26C196" } },
              { value: 135, name: "襄阳", itemStyle: { color: "#6EFACC" } },
              { value: 234, name: "鄂州", itemStyle: { color: "#00DDF2" } },
              { value: 135, name: "宜昌", itemStyle: { color: "#00B6FF" } },
              { value: 310, name: "十堰", itemStyle: { color: "#3482FF" } },
              { value: 135, name: "孝感", itemStyle: { color: "#7172EA" } },
              { value: 135, name: "荆门", itemStyle: { color: "#8F63D2" } },
              { value: 135, name: "鄂州", itemStyle: { color: "#D674E9" } },
              { value: 135, name: "黄冈", itemStyle: { color: "#FF73B7" } },
              { value: 135, name: "咸宁", itemStyle: { color: "#FF9583" } },
              { value: 148, name: "随州", itemStyle: { color: "#FFC862" } }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              },
              normal: {
                label: {
                  show: true,
                  formatter: "{b} : {c} ({d}%)"
                },
                labelLine: { show: true }
              }
            }
          }
          /* {
            name: "访问来源",
            type: "pie",
            // radius: ['40%', '55%'],
            label: {
              formatter: "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
              backgroundColor: "#eee",
              borderColor: "#aaa",
              borderWidth: 1,
              borderRadius: 4,
              // shadowBlur:3,
              // shadowOffsetX: 2,
              // shadowOffsetY: 2,
              // shadowColor: '#999',
              // padding: [0, 7],
              rich: {
                a: {
                  color: "#999",
                  lineHeight: 22,
                  align: "center"
                },
                // abg: {
                //     backgroundColor: '#333',
                //     width: '100%',
                //     align: 'right',
                //     height: 22,
                //     borderRadius: [4, 4, 0, 0]
                // },
                hr: {
                  borderColor: "#aaa",
                  width: "100%",
                  borderWidth: 0.5,
                  height: 0
                },
                b: {
                  fontSize: 14,
                  lineHeight: 20
                },
                per: {
                  color: "#eee",
                  backgroundColor: "#334455",
                  padding: [2, 4],
                  borderRadius: 2
                }
              }
            },
            data: [
              { value: 335, name: "武汉" },
              { value: 310, name: "十堰" },
              { value: 234, name: "鄂州" },
              { value: 135, name: "荆门" },
              { value: 135, name: "黄石" },
              { value: 135, name: "宜昌" },
              { value: 135, name: "孝感" },
              { value: 135, name: "咸宁" },
              { value: 148, name: "随州" }
            ]
          } */
        ]
      },
      // 各专业报名人数情况
      specialData: {
        color: ["#3398DB"],
        title: {
          text: "各专业报名人数情况",
          left: "center"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: [
              "质量员",
              "材料员",
              "施工员",
              "资料员",
              "标准员",
              "劳务员",
              "机械员"
            ],
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            name: "报名人数",
            type: "bar",
            barWidth: "30%",
            //顶部数字展示pzr
            itemStyle: {
              //柱形图圆角，鼠标移上去效果
              // emphasis: {
              //   barBorderRadius: [10, 10, 10, 10]
              // },
              normal: {
                //柱形图圆角，初始化效果
                barBorderRadius: [100, 100, 0, 0],
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#00DEFF"
                  },
                  {
                    offset: 1,
                    color: "#3482FF"
                  }
                ])
              }
            },
            data: [100, 152, 200, 334, 390, 330, 220]
          }
        ]
      },
      // 各地市报名人数增长情况
      cityData: {
        color: ["#3398DB"],
        title: {
          text: "各地市报名人数增长情况",
          left: "center"
        },
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          type: "category",
          data: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月"
          ]
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "报名人数",
            type: "line",
            itemStyle: {
              //柱形图圆角，鼠标移上去效果
              // emphasis: {
              //   barBorderRadius: [10, 10, 10, 10]
              // },
              normal: {
                //柱形图圆角，初始化效果
                // barBorderRadius: [100, 100, 0, 0],
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#00DEFF"
                  },
                  {
                    offset: 1,
                    color: "#3482FF"
                  }
                ])
              }
            },
            areaStyle: {
              normal: {
                color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#00DEFF" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(52,130,255,0)" // 100% 处的颜色
                    }
                  ],
                  globalCoord: false // 缺省为 false
                }
              }
            },
            data: [350, 300, 360, 320, 820, 260, 332, 301, 334, 390, 330, 320]
          }
        ]
      },
      // 各机构报名人数增长情况
      organData: {
        color: ["#3398DB"],
        title: {
          text: "各机构报名人数增长情况",
          left: "center"
        },
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          type: "category",
          data: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月"
          ]
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "报名人数",
            type: "line",
            itemStyle: {
              //柱形图圆角，鼠标移上去效果
              // emphasis: {
              //   barBorderRadius: [10, 10, 10, 10]
              // },
              normal: {
                //柱形图圆角，初始化效果
                // barBorderRadius: [100, 100, 0, 0],
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#00DEFF"
                  },
                  {
                    offset: 1,
                    color: "#3482FF"
                  }
                ])
              }
            },
            areaStyle: {
              normal: {
                color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#00DEFF" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(52,130,255,0)" // 100% 处的颜色
                    }
                  ],
                  globalCoord: false // 缺省为 false
                }
              }
            },
            data: [450, 360, 380, 280, 620, 290, 332, 385, 234, 350, 380, 320]
          }
        ]
      },
      // 各专业报名人数增长情况
      majorData: {
        color: ["#3398DB"],
        title: {
          text: "各专业报名人数增长情况",
          left: "center"
        },
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          type: "category",
          data: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月"
          ]
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "报名人数",
            type: "line",
            itemStyle: {
              //柱形图圆角，鼠标移上去效果
              // emphasis: {
              //   barBorderRadius: [10, 10, 10, 10]
              // },
              normal: {
                //柱形图圆角，初始化效果
                // barBorderRadius: [100, 100, 0, 0],
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#00DEFF"
                  },
                  {
                    offset: 1,
                    color: "#3482FF"
                  }
                ])
              }
            },
            areaStyle: {
              normal: {
                color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#00DEFF" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(52,130,255,0)" // 100% 处的颜色
                    }
                  ],
                  globalCoord: false // 缺省为 false
                }
              }
            },
            data: [450, 560, 380, 180, 520, 390, 232, 395, 200, 350, 310, 220]
          }
        ]
      }
    };
  },
  mounted() {
    // this.drawLine();
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "各地市州报名人数",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: [
            "武汉",
            "十堰",
            "鄂州",
            "荆门",
            "黄石",
            "宜昌",
            "襄樊",
            "孝感",
            "咸宁",
            "随州"
          ]
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              { value: 335, name: "武汉" },
              { value: 310, name: "十堰" },
              { value: 234, name: "鄂州" },
              { value: 135, name: "荆门" },
              { value: 135, name: "黄石" },
              { value: 135, name: "宜昌" },
              { value: 135, name: "孝感" },
              { value: 135, name: "咸宁" },
              { value: 148, name: "随州" }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-date-editor.el-input,
.el-date-editor.el-input__inner,
/deep/.el-select {
  width: 110px !important;
}
/deep/.el-input__inner {
  border-color: #409eff;
  // background: rgba(64, 158, 255, 0.2);
}
.bg-purple {
  background: url("../assets/images/system.png") no-repeat center;
  background-size: 100% 100%;
}
.grid-content {
  border-radius: 6px;
  min-height: 130px;
}
.home {
  padding: 20px;
}
.tabs {
  color: #ffffff;
  font-size: 22px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 20px 0;
  .title {
    font-weight: normal;
  }
  .num {
    font-size: 34px;
  }
}
.echart {
  margin-top: 20px;
  .com {
    height: 360px;
    background: #fff;
    padding: 10px;
    border-radius: 6px;
    box-shadow: 0px 8px 10px 0px rgba(52, 130, 255, 0.15);
    position: relative;
    .title {
      text-align: center;
      margin-bottom: 10px;
    }
    .picker {
      position: absolute;
      right: 10px;
      top: 10px;
    }
    .select {
      width: 230px;
      position: absolute;
      top: 36px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

@media screen and (max-width: 1366px) {
  /deep/.el-col.el-col-4,
  /deep/.el-col.el-col-8 {
    padding: 0 10px !important;
  }
  // /deep/.el-date-editor.el-input,
  // .el-date-editor.el-input__inner,
  // /deep/.el-select {
  //   width: 90px !important;
  // }
  .tabs {
    font-size: 18px;
    .num {
      font-size: 28px;
    }
  }
  .grid-content {
    min-height: 100px;
  }
  #myChart {
    width: 80% !important;
    height: 80% !important;
  }
}
</style>